import {
  useCallback, useContext, useEffect, useState, useRef,
} from 'react';
import { getConfig } from '@edx/frontend-platform';
import { getLocale } from '@edx/frontend-platform/i18n';

import { AppDataContext } from '../context';
import { updateLanguagePreference, DEFAULT_LANGUAGE } from '../utils';

export function useLanguageSwitcher() {
  const { authenticatedUser } = useContext(AppDataContext);
  const [locale, setLocale] = useState<string>(getLocale() || DEFAULT_LANGUAGE);
  const shouldPageReload = useRef<boolean>(false);

  const { username = '' } = authenticatedUser ?? {};

  useEffect(() => {
    updateLanguagePreference(Boolean(authenticatedUser), locale, username, shouldPageReload.current);
    shouldPageReload.current = false;
  }, [username, getConfig().LMS_BASE_URL, locale]);

  useEffect(() => {
    setLocale(getLocale() || 'en');
  }, [getLocale()]);

  const handleSelectLanguage = useCallback((lang: string): void => {
    setLocale(lang);
    shouldPageReload.current = true;
  }, []);

  return { handleSelectLanguage, locale };
}
